const LOCALE = {
  // Countries accepted by the book-request deep-link, set per environment
  // (e.g. "DEV,PE" in dev, "PE" in prod). Defaults to PE if the var is missing.
  COUNTRY_CODES_BOOK_REQUEST: (process.env.VUE_APP_COUNTRY_CODES_BOOK_REQUEST || 'PE')
    .split(',')
    .map(code => code.trim().toUpperCase())
    .filter(Boolean),
  LANGUAGES: ['es', 'pt', 'en'],
}

export default LOCALE
